import { Link } from "react-router-dom";
import { LogoMark } from "@/components/app/Brand";
import { ArrowLeft, ArrowRight, Heart, Globe, Zap, Users, Mail } from "lucide-react";

const VALUES = [
  { icon: Zap, title: "Ship fast, ship real", desc: "We build for consultancies and delivery teams who live in this tool every day — we feel the same urgency they do." },
  { icon: Users, title: "Small team, real ownership", desc: "Every hire shapes the product roadmap. No layers of process between an idea and shipping it." },
  { icon: Globe, title: "Remote-first", desc: "We hire across time zones and optimise for async communication and deep work." },
  { icon: Heart, title: "Customer-obsessed", desc: "We talk to the agencies and PMOs using CombinedWork every week, and it shows in what we prioritise." },
];

export default function Careers() {
  return (
    <div className="bg-white text-gray-900 min-h-screen font-sans">
      <nav className="border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-violet-600 grid place-items-center shadow-md shadow-violet-200">
              <LogoMark size={16} color="#fff" />
            </div>
            <span className="text-base font-bold text-gray-900 tracking-tight">Combined<span className="text-violet-600">Work</span></span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to home
          </Link>
        </div>
      </nav>

      <header className="max-w-3xl mx-auto px-6 pt-20 pb-12 text-center">
        <span className="inline-block px-4 py-1.5 bg-violet-100 text-violet-600 text-xs font-semibold rounded-full mb-4">Careers</span>
        <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tight text-gray-900 mb-4">
          Help us build the tool we wished we had
        </h1>
        <p className="text-gray-500 text-lg max-w-xl mx-auto">
          CombinedWork is a small team replacing the tool-stack sprawl of Jira, Notion, Slack, and HubSpot with one
          connected platform. We're just getting started.
        </p>
      </header>

      <section className="max-w-4xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {VALUES.map((v) => (
            <div key={v.title} className="border border-gray-100 rounded-2xl p-6 hover:shadow-lg hover:shadow-gray-100 transition-all">
              <div className="w-10 h-10 rounded-xl bg-violet-50 grid place-items-center mb-4">
                <v.icon className="w-5 h-5 text-violet-600" strokeWidth={1.75} />
              </div>
              <h3 className="font-semibold text-gray-800 text-sm mb-2">{v.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-16 text-center">
        <div className="border border-gray-100 rounded-2xl p-10 bg-gray-50">
          <h2 className="font-display font-bold text-2xl text-gray-900 mb-3">We're hiring</h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto mb-8">
            We hire selectively as the team grows, so we don't always have every role posted. Send us your CV and
            what you'd want to work on, and we'll reach out when there's a fit.
          </p>
          <a href="mailto:careers@combinedwork.com?subject=Interested%20in%20CombinedWork"
            className="inline-flex items-center gap-2 px-6 py-3 bg-violet-600 text-white text-sm font-bold rounded-full hover:bg-violet-700 transition-all hover:scale-105 shadow-md shadow-violet-200">
            <Mail className="w-4 h-4" /> Email careers@combinedwork.com <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>

      <footer className="border-t border-gray-100 py-8 px-6 text-center">
        <span className="text-xs text-gray-400">&copy; {new Date().getFullYear()} CombinedWork. All rights reserved.</span>
      </footer>
    </div>
  );
}
